/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {Crypto} from '@peculiar/webcrypto';

/**
 * Defines polyfills required by the application at build time, specifically
 * those which need to be shimmed in order to support statically generated
 * pages at build time.
 */

/**
 * Since the global crypto dependency is not available at build time during
 * static site generation (SSG), we need to polyfill it accordingly.
 */
if (!globalThis.crypto) {
  globalThis.crypto = new Crypto();
} else if (!globalThis.crypto.getRandomValues) {
  globalThis.crypto.getRandomValues = (buffer) => new Crypto().getRandomValues(buffer);
}
